import React, { useRef, useEffect } from 'react';

export function TimePicker({ value, onChange }) {
  // value is a Date object (or null)
  // onChange is called with (hours, minutes)
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: 12 }, (_, i) => i * 5);

  const selectedHour = value ? value.getHours() : 0;
  // Round to nearest 5 minutes
  const selectedMinute = value ? Math.round(value.getMinutes() / 5) * 5 : 0;

  const hoursRef = useRef(null);
  const minutesRef = useRef(null);

  useEffect(() => {
    // Scroll selected items into view on load
    if (hoursRef.current) {
      const selectedEl = hoursRef.current.querySelector('[data-selected="true"]');
      if (selectedEl) {
        selectedEl.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
    }
    if (minutesRef.current) {
      const selectedEl = minutesRef.current.querySelector('[data-selected="true"]');
      if (selectedEl) {
        selectedEl.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
    }
  }, [selectedHour, selectedMinute]);

  return (
    <div className="flex h-[var(--calendar-timepicker-height,18rem)] border-l border-border bg-card">
      {/* Hours Column */}
      <div
        ref={hoursRef}
        className="flex flex-col overflow-y-auto w-16 border-r border-border py-1 select-none"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {hours.map((h) => {
          const isSelected = h === selectedHour;
          return (
            <button
              key={h}
              type="button"
              data-selected={isSelected}
              onClick={() => onChange(h, selectedMinute)}
              className={`text-xs py-[var(--calendar-timepicker-row-padding,0.5rem)] px-2 hover:bg-accent hover:text-accent-foreground text-center transition-colors shrink-0 font-medium ${
                isSelected
                  ? 'bg-primary text-primary-foreground font-bold hover:bg-primary hover:text-primary-foreground'
                  : 'text-foreground'
              }`}
            >
              {String(h).padStart(2, '0')}
            </button>
          );
        })}
      </div>
      {/* Minutes Column */}
      <div
        ref={minutesRef}
        className="flex flex-col overflow-y-auto w-16 py-1 select-none"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {minutes.map((m) => {
          const isSelected = m === selectedMinute;
          return (
            <button
              key={m}
              type="button"
              data-selected={isSelected}
              onClick={() => onChange(selectedHour, m)}
              className={`text-xs py-[var(--calendar-timepicker-row-padding,0.5rem)] px-2 hover:bg-accent hover:text-accent-foreground text-center transition-colors shrink-0 font-medium ${
                isSelected
                  ? 'bg-primary text-primary-foreground font-bold hover:bg-primary hover:text-primary-foreground'
                  : 'text-foreground'
              }`}
            >
              {String(m).padStart(2, '0')}
            </button>
          );
        })}
      </div>
    </div>
  );
}
